let password = {
    init() {
        this.eyeToggle();
    },
    eyeToggle() {
        $('a.icone-pwd').on('click', function() {
            $(this).toggleClass('active');
            let input = $(this).parent().find('input');
            let type = input.attr('type') === 'password' ? 'text' : 'password';
            input.attr('type', type);
        });
    }
}

export default password;
